import {useContext, useState} from 'react'
import { Form, FormGroup, Label, Input, Button } from 'reactstrap'
import { Link, useHistory } from 'react-router-dom'
import {GlobalContext} from '../context/GlobalState'
import { v4 as uuid } from 'uuid'

const AddUser = () => {
   const {addUser} = useContext(GlobalContext) 
   const [name, setName] = useState('')
   const history = useHistory()

   const onSubmit = (user) => {
      const newUser = {
         id: uuid(),
         name: name
      }
      addUser(newUser)
      history.push('/')
   }

   const handleChange = (e) => {
      setName(e.target.value)  
   }

    return (
       <Form onSubmit={onSubmit}>
         <FormGroup>
            <Label>Name</Label>
            <Input type="text" value={name}  onChange={handleChange} placeholder="Enter Name.." style={{marginBottom: '.5rem'}}></Input>
         </FormGroup>
         
            
        <Button type="submit">Submit</Button>
        <Link to="/" className="btn btn-danger ml-2" style={{marginLeft: '.5rem'}}>Cancel</Link>
       </Form>
    )
}

export default AddUser
